import React from 'react';
import { CheckCircleIcon, TruckIcon, ClockIcon, AlertTriangleIcon } from 'lucide-react';
interface ShipmentStatusBadgeProps {
  status: string;
  className?: string;
}
const ShipmentStatusBadge: React.FC<ShipmentStatusBadgeProps> = ({
  status,
  className = ''
}) => {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'Delivered':
        return {
          icon: <CheckCircleIcon size={16} className="text-green-600" data-id="element-429" />,
          classes: 'bg-green-50 text-green-700 border-green-200'
        };
      case 'In Transit':
        return {
          icon: <TruckIcon size={16} className="text-blue-600" data-id="element-430" />,
          classes: 'bg-blue-50 text-blue-700 border-blue-200'
        };
      case 'Pending Pickup':
        return {
          icon: <ClockIcon size={16} className="text-amber-600" data-id="element-431" />,
          classes: 'bg-amber-50 text-amber-700 border-amber-200'
        };
      case 'Delayed':
        return {
          icon: <AlertTriangleIcon size={16} className="text-red-600" data-id="element-432" />,
          classes: 'bg-red-50 text-red-700 border-red-200'
        };
      default:
        return {
          icon: <ClockIcon size={16} className="text-gray-600" data-id="element-433" />,
          classes: 'bg-gray-50 text-gray-700 border-gray-200'
        };
    }
  };
  const config = getStatusConfig(status);
  return <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${config.classes} ${className}`} data-id="element-434">
      {config.icon}
      <span className="ml-2" data-id="element-435">{status}</span>
    </span>;
};
export default ShipmentStatusBadge;